import Blocks from '@/components/Blocks';
import CommunityIndex from '@/components/CommunityIndex';
import PageHeader from '@/components/PageHeader';
import { BoxProps } from '@/components/ui/Box';
import LayoutDefault from '@/layouts/Layout';
import { PageEntryTypes } from '@/lib/parsers/entries';
import { Fragment, type ReactNode } from 'react';

export type DefaultLayoutProps = BoxProps<
  'div',
  {
    entry: PageEntryTypes;
    nav: ReactNode;
    footer: ReactNode;
    latestArticles?: ReactNode;
    searchIndex?: ReactNode;
  }
>;

const DefaultLayout = ({
  entry,
  nav,
  footer,
  latestArticles,
  searchIndex,
  colorTheme = 'default',
  ...props
}: DefaultLayoutProps) => {
  return (
    <LayoutDefault
      {...{ entry, colorTheme, ...props }}
      slots={{
        nav,
        header: <PageHeader entry={entry} />,
        body: [
          <CommunityIndex key="communityIndex" />,
          <Fragment key="searchIndex">{searchIndex}</Fragment>,
          <Blocks key="blocks" />,
          <Fragment key="latestArticles">{latestArticles}</Fragment>,
        ],
        footer,
      }}
    />
  );
};

export default DefaultLayout;
